import { MetricResultDto } from '../../../../../../../typescript-axios';
import { CardParameters } from '../config';

interface CardVisualizationProps {
    data: MetricResultDto;
    parameters?: CardParameters;
}

export function CardVisualization({ data, parameters }: CardVisualizationProps) {
    const title = parameters?.title ?? '';
    const icon = parameters?.icon ?? 'users';
    const color = parameters?.color ?? 'green';

    const formattedValue = new Intl.NumberFormat().format(data.result);

    return (
        <div className="surface-card shadow-2 p-3 border-round-xl flex align-items-center h-full">
            <div
                className={`bg-${color}-100 border-round-lg flex align-items-center justify-content-center flex-shrink-0`}
                style={{ width: '4rem', height: '4rem' }}
            >
                <i className={`pi pi-${icon} text-${color}-600 text-2xl`}></i>
            </div>
            <div className="ml-3">
                <span className="text-600 font-medium block mb-1">
                    {title}
                </span>
                <span className="text-900 font-bold text-2xl">
                    {formattedValue}
                </span>
            </div>
        </div>
    );
}